const baseRoute = 'law-finder/:moduleBridgeHex/';
export const routes = {
  // user_module_lawFinder_base: {
  //   path: baseRoute,
  //   parameters: {
  //     moduleBridgeHex: undefined,
  //   },
  // },
  user_module_lawFinder_home: {
    path: `${baseRoute}home/:page/:filters/`,
    parameters: {
      moduleBridgeHex: undefined,
      page: 1,
      filters: 0,
    },
  },
};
